import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchEmailNotifications, updateEmailNotification } from "./emailnotifications.api";
import { keys } from "./keys";

export const useEmailNotificationsQuery = (enabled) => useQuery({
    queryKey: keys.emailNotifications.list(),
    queryFn: fetchEmailNotifications,
    enabled
});

export const useUpdateEmailNotification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateEmailNotification,
        onMutate: () => queryClient.cancelQueries({ queryKey: keys.emailNotifications.list() }),
        onSuccess: (event) => {
            queryClient.setQueryData(keys.emailNotifications.list(), (previous) => previous ? {
                ...previous,
                events: previous.events.map((item) => item.eventId === event.eventId ? event : item)
            } : previous);
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: keys.emailNotifications.list() })
    });
};
